import React from 'react';
import { Form, Field, FieldArray, useFormikContext } from 'formik';
import { Button, Grid, Divider, IconButton, Typography, Tooltip, Zoom, Link as MuiLink } from '@mui/material';
import { TextField } from 'formik-mui';
import { referenceDataSchema, referenceDataValueSchema } from '../ReferenceDataDetailContext';
import * as yup from 'yup';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import theme from 'assets';

let ReferenceDataForm = () => {
    let router = useLocation();

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'New reference data' : 'Edit reference data';

    type ReferenceData = yup.InferType<typeof referenceDataSchema>;

    let form = useFormikContext<ReferenceData>();


    return (
        <Form>
            <Grid container spacing={2} alignItems='center'>
                <Grid item xs>
                    <Typography variant="h4">{title}</Typography>
                </Grid>
                <Grid item>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="medium"
                        component={Link}
                        to={'/admin/referencedata'}
                    >
                        Cancel
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        type="submit"
                        variant="contained"
                        size="medium"
                        color="primary"
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
            {isNew === false && <Typography variant="h4">{form.values.key}</Typography>}
            {isNew === true &&
                <Field
                    component={TextField}
                    name="key"
                    fullWidth
                    margin="dense"
                    size='small'
                    label="Key"
                />
            }
            <Divider />
            <FieldArray name="values">
                {helpers =>
                    <>
                        <Grid container spacing={2} marginBottom={theme.spacing()}>
                            <Grid item xs />
                            <Grid item>
                                <MuiLink
                                    component="button"
                                    type="button"
                                    onClick={() => {
                                        let maxSort = form.values.values.length === 0 ? 0 : Math.max(...form.values.values.map(x => x.sortOrder));

                                        helpers.insert(0, {
                                            ...referenceDataValueSchema.getDefault(),
                                            sortOrder: maxSort + 1
                                        })
                                    }}
                                >
                                    New value
                                </MuiLink>
                            </Grid>
                        </Grid>
                        {form.values.values
                            .map((value, index) =>
                                <Grid container spacing={2} key={index} alignItems='center'>
                                    <Grid item xs={3}>
                                        {value.isNew === true &&
                                            <Field
                                                component={TextField}
                                                name={`values[${index}].key`}
                                                label="Key"
                                                fullWidth
                                                margin="dense"
                                                size='small'
                                            />
                                        }
                                        {!value.isNew && <Typography gutterBottom>{value.key}</Typography>}
                                    </Grid>
                                    <Grid item xs>
                                        <Field
                                            component={TextField}
                                            name={`values[${index}].description`}
                                            label="Description"

                                            margin="dense"
                                            size='small'
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Field
                                            component={TextField}
                                            name={`values[${index}].sortOrder`}
                                            label="Sort order"
                                            type="number"

                                            margin="dense"
                                            size='small'
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Grid container spacing={1}>
                                            <Grid item>
                                                <Tooltip title="Remove" TransitionComponent={Zoom}>
                                                    <IconButton
                                                        color="secondary"
                                                        size="small"
                                                        onClick={() => helpers.remove(index)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                    </>
                }
            </FieldArray>
        </Form>
    )
}

export default ReferenceDataForm;